import Heading from "components/Heading/Heading";
import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import HIW1img from "images/Gotoplaces1.png";
import HIW2img from "images/Gotoplaces2.png";
import HIW3img from "images/Gotoplaces3.png";
import VectorImg from "images/VectorHIW.svg";

export interface SectionHowItWorkProps {
  className?: string;
  data?: {
    id: number;
    title: string;

    img: string;
    imgDark?: string;
  }[];
}

const DEMO_DATA: SectionHowItWorkProps["data"] = [
  {
    id: 1,
    img: HIW1img,
    title: "Visa",
  },
  {
    id: 2,
    img: HIW2img,
    title: "Mastercard",
  },
  {
    id: 3,
    img: HIW3img,
    title: "American Express",
  },
];

const GoPlacesWith: FC<SectionHowItWorkProps> = ({
  className = "",
  data = DEMO_DATA,
}) => {
  return (
    <div
      className={`nc-SectionHowItWork  ${className}`}
      data-nc-id="SectionHowItWork"
    >
      <div className="flex flex-col mb-8 relative">
        <span className=" text-3xl md:text-4xl font-semibold leading-6 md:leading-10 text-center">
          Payment Methods
        </span>
      </div>
      <div className="flex justify-center">
        <span className="text-base font-normal px-5 md:px-0 leading-6 text-center text-[#6B7280]">
          VISA, Mastercard, Discover, and American Express are the
          preferred method of payment for rental
          <br /> fees and security deposits. In certain cases, wire transfers
          are also accepted.
        </span>
      </div>
      <div className="mt-20 relative grid md:grid-cols-3 gap-20 md:mx-44 mx-4">
        <img
          className="hidden md:block absolute inset-x-0 top-10"
          src={VectorImg}
          alt=""
        />
        {data.map((item) => (
          <div
            key={item.id}
            className="relative flex flex-col items-center max-w-xs mx-auto"
          >
            <NcImage
              containerClassName="mx-auto"
              src={item.img}
            />

            <div className="text-center mt-auto">
              <span className="text-xl font-semibold md:leading-7 leading-5 text-center">
                {item.title}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoPlacesWith;
